import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2c2c30d4 = () => interopDefault(import('../pages/discover/index.vue' /* webpackChunkName: "pages/discover/index" */))
const _556dc2da = () => interopDefault(import('../pages/get-started/index.vue' /* webpackChunkName: "pages/get-started/index" */))
const _407db405 = () => interopDefault(import('../pages/onboarding.vue' /* webpackChunkName: "pages/onboarding" */))
const _7b9700f2 = () => interopDefault(import('../pages/password-reset.vue' /* webpackChunkName: "pages/password-reset" */))
const _211f388a = () => interopDefault(import('../pages/sign-in.vue' /* webpackChunkName: "pages/sign-in" */))
const _0406ba31 = () => interopDefault(import('../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _b08b1d74 = () => interopDefault(import('../pages/business/sign-up.vue' /* webpackChunkName: "pages/business/sign-up" */))
const _1d064932 = () => interopDefault(import('../pages/business/travelers.vue' /* webpackChunkName: "pages/business/travelers" */))
const _c4b2857e = () => interopDefault(import('../pages/discover/bookmarks.vue' /* webpackChunkName: "pages/discover/bookmarks" */))
const _d070e5e2 = () => interopDefault(import('../pages/mcp/auth-complete.vue' /* webpackChunkName: "pages/mcp/auth-complete" */))
const _6822d66e = () => interopDefault(import('../pages/pro/features.vue' /* webpackChunkName: "pages/pro/features" */))
const _561f52cc = () => interopDefault(import('../pages/pro/subscriptions.vue' /* webpackChunkName: "pages/pro/subscriptions" */))
const _6e3c7627 = () => interopDefault(import('../pages/pro/success.vue' /* webpackChunkName: "pages/pro/success" */))
const _107db64c = () => interopDefault(import('../pages/user/packing-lists/index.vue' /* webpackChunkName: "pages/user/packing-lists/index" */))
const _5b025a26 = () => interopDefault(import('../pages/user/settings.vue' /* webpackChunkName: "pages/user/settings" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0211fb34 = () => interopDefault(import('../pages/discover/categories/_categories.vue' /* webpackChunkName: "pages/discover/categories/_categories" */))
const _886babc8 = () => interopDefault(import('../pages/discover/inspiration/_inspiration.vue' /* webpackChunkName: "pages/discover/inspiration/_inspiration" */))
const _60a92c4c = () => interopDefault(import('../pages/discover/search/_search.vue' /* webpackChunkName: "pages/discover/search/_search" */))
const _056117d0 = () => interopDefault(import('../pages/user/packing-lists/_packingList.vue' /* webpackChunkName: "pages/user/packing-lists/_packingList" */))
const _10c97fa6 = () => interopDefault(import('../pages/get-started/_session.vue' /* webpackChunkName: "pages/get-started/_session" */))
const _0c87d0ba = () => interopDefault(import('../pages/trip/_id.vue' /* webpackChunkName: "pages/trip/_id" */))
const _43013886 = () => interopDefault(import('../pages/trip/_id/index.vue' /* webpackChunkName: "pages/trip/_id/index" */))
const _0bc2a23d = () => interopDefault(import('../pages/trip/_id/chat.vue' /* webpackChunkName: "pages/trip/_id/chat" */))
const _f3c46c00 = () => interopDefault(import('../pages/trip/_id/expenses.vue' /* webpackChunkName: "pages/trip/_id/expenses" */))
const _79d3fa2c = () => interopDefault(import('../pages/trip/_id/notes.vue' /* webpackChunkName: "pages/trip/_id/notes" */))
const _de61a0a2 = () => interopDefault(import('../pages/trip/_id/notes/index.vue' /* webpackChunkName: "pages/trip/_id/notes/index" */))
const _71a24eb5 = () => interopDefault(import('../pages/trip/_id/notes/_notes.vue' /* webpackChunkName: "pages/trip/_id/notes/_notes" */))
const _0bf069df = () => interopDefault(import('../pages/trip/_id/packing-lists/index.vue' /* webpackChunkName: "pages/trip/_id/packing-lists/index" */))
const _109b5e3e = () => interopDefault(import('../pages/trip/_id/subscriptions.vue' /* webpackChunkName: "pages/trip/_id/subscriptions" */))
const _e6c1a180 = () => interopDefault(import('../pages/trip/_id/packing-lists/template/index.vue' /* webpackChunkName: "pages/trip/_id/packing-lists/template/index" */))
const _0115cdc7 = () => interopDefault(import('../pages/trip/_id/packing-lists/template/_template.vue' /* webpackChunkName: "pages/trip/_id/packing-lists/template/_template" */))
const _236d840a = () => interopDefault(import('../pages/trip/_id/conversation/_conversation.vue' /* webpackChunkName: "pages/trip/_id/conversation/_conversation" */))
const _0f5a7b22 = () => interopDefault(import('../pages/trip/_id/documents/_file.vue' /* webpackChunkName: "pages/trip/_id/documents/_file" */))
const _66d0132b = () => interopDefault(import('../pages/trip/_id/packing-lists/_packingList.vue' /* webpackChunkName: "pages/trip/_id/packing-lists/_packingList" */))
const _5ead46b2 = () => interopDefault(import('../pages/trip/_id/photos/_file.vue' /* webpackChunkName: "pages/trip/_id/photos/_file" */))
const _362af4d6 = () => interopDefault(import('../pages/trip/_id/waypoints/_waypoints.vue' /* webpackChunkName: "pages/trip/_id/waypoints/_waypoints" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/discover",
    component: _2c2c30d4,
    name: "discover"
  }, {
    path: "/get-started",
    component: _556dc2da,
    name: "get-started"
  }, {
    path: "/onboarding",
    component: _407db405,
    name: "onboarding"
  }, {
    path: "/password-reset",
    component: _7b9700f2,
    name: "password-reset"
  }, {
    path: "/sign-in",
    component: _211f388a,
    name: "sign-in"
  }, {
    path: "/sign-up",
    component: _0406ba31,
    name: "sign-up"
  }, {
    path: "/business/sign-up",
    component: _b08b1d74,
    name: "business-sign-up"
  }, {
    path: "/business/travelers",
    component: _1d064932,
    name: "business-travelers"
  }, {
    path: "/discover/bookmarks",
    component: _c4b2857e,
    name: "discover-bookmarks"
  }, {
    path: "/mcp/auth-complete",
    component: _d070e5e2,
    name: "mcp-auth-complete"
  }, {
    path: "/pro/features",
    component: _6822d66e,
    name: "pro-features"
  }, {
    path: "/pro/subscriptions",
    component: _561f52cc,
    name: "pro-subscriptions"
  }, {
    path: "/pro/success",
    component: _6e3c7627,
    name: "pro-success"
  }, {
    path: "/user/packing-lists",
    component: _107db64c,
    name: "user-packing-lists"
  }, {
    path: "/user/settings",
    component: _5b025a26,
    name: "user-settings"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/discover/categories/:categories?",
    component: _0211fb34,
    name: "discover-categories-categories"
  }, {
    path: "/discover/inspiration/:inspiration?",
    component: _886babc8,
    name: "discover-inspiration-inspiration"
  }, {
    path: "/discover/search/:search?",
    component: _60a92c4c,
    name: "discover-search-search"
  }, {
    path: "/user/packing-lists/:packingList?",
    component: _056117d0,
    name: "user-packing-lists-packingList"
  }, {
    path: "/get-started/:session?",
    component: _10c97fa6,
    name: "get-started-session"
  }, {
    path: "/trip/:id?",
    component: _0c87d0ba,
    children: [{
      path: "",
      component: _43013886,
      name: "trip-id"
    }, {
      path: "chat",
      component: _0bc2a23d,
      name: "trip-id-chat"
    }, {
      path: "expenses",
      component: _f3c46c00,
      name: "trip-id-expenses"
    }, {
      path: "notes",
      component: _79d3fa2c,
      children: [{
        path: "",
        component: _de61a0a2,
        name: "trip-id-notes"
      }, {
        path: ":notes",
        component: _71a24eb5,
        name: "trip-id-notes-notes"
      }]
    }, {
      path: "packing-lists",
      component: _0bf069df,
      name: "trip-id-packing-lists"
    }, {
      path: "subscriptions",
      component: _109b5e3e,
      name: "trip-id-subscriptions"
    }, {
      path: "packing-lists/template",
      component: _e6c1a180,
      name: "trip-id-packing-lists-template"
    }, {
      path: "packing-lists/template/:template",
      component: _0115cdc7,
      name: "trip-id-packing-lists-template-template"
    }, {
      path: "conversation/:conversation?",
      component: _236d840a,
      name: "trip-id-conversation-conversation"
    }, {
      path: "documents/:file?",
      component: _0f5a7b22,
      name: "trip-id-documents-file"
    }, {
      path: "packing-lists/:packingList?",
      component: _66d0132b,
      name: "trip-id-packing-lists-packingList"
    }, {
      path: "photos/:file?",
      component: _5ead46b2,
      name: "trip-id-photos-file"
    }, {
      path: "waypoints/:waypoints?",
      component: _362af4d6,
      name: "trip-id-waypoints-waypoints"
    }]
  }, {
    path: "/trips",
    component: _2dfb1658,
    name: "trips"
  }, {
    path: "/archive",
    component: _2dfb1658,
    name: "archive"
  }, {
    path: "/trip/:id/waypoints/:waypoints/places/:places",
    component: _362af4d6,
    name: "places"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
